import { SECOND } from '@/constants';

export const ANIMATION_DURATION = 0.1;
export const DEBOUNCE_TIME = (ANIMATION_DURATION + 0.02) * SECOND;
export const GNB_DROP_DOWN_MENU_CONTENT_ID = 'gnb-dropdown-menu-content';
